import { render, staticRenderFns } from "./LeadCategoriesList.vue?vue&type=template&id=2b0a51a7&"
import script from "./LeadCategoriesList.vue?vue&type=script&lang=js&"
export * from "./LeadCategoriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports